<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>

		</div>
		
		<div class="btn_wrap">
			<p class="btn" :class="percentage == 100?'':'disabled'" @click="preview()">打印预览</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { getLodop } from '@/assets/js/utils/LodopFuncs'
export default {
	name: "orderPrintProcess",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		print_order_id: {
			type: Array,
			default: []
		},
	},
	data() {
		return {
			loading: false,
			arr_ids:[],
			percentage:0,
			print_template:[],
			supplier_kdn_lcb:[]
		};
	},
	
	created(){
		this.init()
	},
	mounted() {
	},
	
	computed:{
		...mapState({
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.arr_ids = []
				this.percentage = 0
				this.print_template = []
				this.supplier_kdn_lcb = []
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getOrderPrintInfo:"ucenter/getOrderPrintInfo",
		}),
		init(){
			this.arr_ids = this.print_order_id
			if(this.print_order_id.length == 0){
				this.$emit('close', {})
				return
			}
			this.getInfo(0)
			
		},
		getInfo(idx){
			var id = this.arr_ids[idx]
			var len = this.arr_ids.length
			this.getOrderPrintInfo({data:{print_order_id:id},success:(res)=>{
				if(res.code == 200){
					this.print_template.push(res.data.print_template)
					this.supplier_kdn_lcb.push(res.data.supplier_kdn_lcb)
				}
				this.percentage = Number((idx+1/len*100).toFixed(2))
				if(idx+1 == len){
					this.preview()
				}else{
					this.getInfo(idx + 1)
				}
			}})
		},
		preview(){
			if(this.percentage != 100){
				return false;
			}
			var htm = this.print_template
			var lcb = this.supplier_kdn_lcb
			const LODOP = getLodop()
			LODOP.PRINT_INIT('打印物流电子面单') // 打印初始化(打印任务名)
			for(var i in htm){
				if(i > 0){
					LODOP.NewPageA();
				}
				LODOP.SET_PRINT_PAGESIZE(1,lcb[i].page_width,lcb[i].page_height ,"")//1竖向 2横向
				LODOP.ADD_PRINT_HTM(3, 3, '100%', '100%', htm[i]) // 添加HTML模板内容
			}
			// LODOP.PRINT(); // 直接打印
			LODOP.PREVIEW() // 预览
		},
		
		cancel(){
			this.$emit('close', {})
		},
		
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn.disabled{background-color: #C0C4CC;color: #333;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	
	.el-input{height: 34px;line-height: 34px;}
	/deep/.el-input__prefix{height:34px;line-height:34px;margin-left:15px;left: 0 !important;}
	/deep/.el-select .el-input__inner{padding-left:80px;height:34px;line-height:34px;}
	/deep/.el-input--prefix .el-input__inner, .el-cascader .el-input .el-input__inner{padding-left:80px;height: 34px !important;}
</style>
